import { render, staticRenderFns } from "./blockAccount.vue?vue&type=template&id=1849d5d9"
import script from "./blockAccount.vue?vue&type=script&lang=js"
export * from "./blockAccount.vue?vue&type=script&lang=js"
import style0 from "./blockAccount.vue?vue&type=style&index=0&id=1849d5d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports